 // Import Asset Image 
import desclogo from "../../assets/images/logo/authlogo.svg"
import logo from "../../assets/images/logo/logo.svg"
import darklogo from "../../assets/images/logo/darklogo.svg"
import darkdesclogo from "../../assets/images/logo/whitelogo.png"

const AuthLogo = ({ jstlogo, desc, mobile, className, auth}) => {
  return (
    <div className={`flex  ${mobile ?  "h-[4rem]" : "h-[6.5rem] py-3"} ${auth ? "mx-auto" : ""} `}>
        <img src={jstlogo ? logo : desclogo} alt="" className={`w-42 object-contain dark:hidden object-center ${className}`} /> 
        <img src={jstlogo ? darklogo : darkdesclogo} alt="" className={`w-42 object-contain object-center hidden dark:flex ${className}`}  /> 
    </div>
  )
}
export default AuthLogo